import { HttpClient } from '@angular/common/http';
import {
    Component,
    OnInit,
    TemplateRef,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/Service/general.service';
import { SubscriptionPlanComponent } from 'src/app/user/subscription-plan/subscription-plan.component';
import Swal from 'sweetalert2';
import { AddUserComponent } from '../add-user/add-user.component';
import { EditDistrictComponent } from '../edit-district/edit-district.component';
import { DatePipe } from '@angular/common';
import { EditstatuspopupComponent } from '../../shared/ui/editstatuspopup/editstatuspopup.component';

class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}
// interface ColumnConfiguration {
//   title: string;
//   data: string | null;
//   render?: (data: any, type: string, row: any, meta: any) => string;
// }

@Component({
    selector: 'app-franchise-user',
    templateUrl: './franchise-user.component.html',
    styleUrls: ['./franchise-user.component.scss'],
})
export class FranchiseUserComponent implements OnInit {
    @ViewChild('content', { static: false }) content: TemplateRef<any>;
    @ViewChild('content1', { static: false }) content1: TemplateRef<any>;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective, { static: false })
    dtElement: DataTableDirective;
    isLoading: boolean = false;
    dtTrigger = new Subject<any>();
    addUserForm: FormGroup;
    UserId: any;
    currentUser: any;
    currentDate: any;
    apiUrl: string;
    jk: any;
    planId: string;
    showAdditionalColumns: boolean = false;
    breadCrumbItems: Array<{}>;
    start: any;
    status: string = '';
    inputValue: string = '';
    dates: any;
    showRow: boolean = false;
    rowData: any;
    usersData: any;
    // rowData: { <T extends string | number | boolean | symbol | object>(element: Document | Element | Window | JQuery.PlainObject<any>, key: string, value: T): T; (element: Document | Element | Window | JQuery.PlainObject<any>, key: string, value: undefined): any; (element: Document | Element | Window | JQuery.PlainObject<any>, key?: string): any; };

    constructor(
        private datepipe: DatePipe,
        private dialog: MatDialog,
        private http: HttpClient,
        private generalService: GeneralService,
        private router: Router
    ) {
        let state = this.router.getCurrentNavigation();
        console.log('state', this.status);
        console.log('sate extras', state.extras);
        if (state.extras.state != undefined) {
            if (state.extras.state.dates) {
                this.dates = state.extras.state.dates;
            }
            if (state.extras.state.status) {
                this.status = state.extras.state.status;
            }
        }
    }

    ngOnInit() {
        // this.User()

        this.showRow = false;
        localStorage.removeItem('UserId');
        localStorage.removeItem('PlanId');
        this.currentUser = this.generalService.getcurrentUser();
        this.currentDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
        this.breadCrumbItems = [
            { label: 'Dashboard', path: '/users' },
            { label: 'User List', path: '/users/users-users/', active: true },
        ];

        localStorage.setItem('UserId', this.UserId);
        localStorage.setItem('planId', this.planId);

        const navState = history.state;

        this.UserId = navState.UserId || localStorage.getItem('UserId');
        this.planId = navState.planId || null;

        if (!this.UserId) {
            console.error('UserId not found in state or localStorage');
        }

        this.dtOptions = {
            pagingType: 'simple_numbers',
            pageLength: 10,
            processing: true,
            serverSide: true,
            ordering: false,
            searching: true,
            order: [[0, 'desc']],
            ajax: (dataTablesParameters: any, callback) => {
                this.start = dataTablesParameters.start;
                this.isLoading = true;
                this.http
                    .get<DataTablesResponse>(
                        `${this.getUrl(dataTablesParameters)}`,
                        {}
                    )
                    .subscribe(
                        (resp: any) => {
                            if (resp.data.length) {
                                callback({
                                    recordsTotal: resp.total,
                                    recordsFiltered: `${
                                        resp.filtercount
                                            ? resp.filtercount
                                            : resp.total
                                    }`,
                                    data: resp.data,
                                });
                                this.rowData = resp.data;
                                this.isLoading = false;
                            } else {
                                callback({
                                    recordsTotal: 0,
                                    recordsFiltered: 0,
                                    data: resp.data,
                                });
                                this.isLoading = false;
                            }
                        },
                        (error) => {
                            Swal.fire({
                                title: error.status,
                                text: 'Internal Server Error',
                                type: 'error',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            this.isLoading = false;
                        }
                    );
            },
            responsive: true,

            columns: [
                {
                    title: 'User Detail',
                    data: null,
                    render: (data) => {
                        // this.UserID = data
                        // console.log("lin267", this.UserID);
                        let statusBadge;
                        if (data.Status === 'Active') {
                            statusBadge =
                                '<span class="badge p-1" style="font-size: 100%; background-color: #0fbd5dff; font-weight: 500;">Active</span>';
                        } else if (data.Status === 'Inactive') {
                            statusBadge =
                                '<span class="badge btn-warning p-1" style="font-size: 100%; font-weight: 500;">Inactive</span>';
                        } else if (data.Status === 'Deactivated') {
                            statusBadge =
                                '<span class="badge btn-danger p-1" style="font-size: 100%; font-weight: 500;">Deactivated</span>';
                        } else if (data.Status === 'Zero') {
                            statusBadge =
                                '<span class="badge btn-danger p-1" style="font-size: 100%; font-weight: 500;">Zero</span>';
                        } else {
                            statusBadge =
                                '<span class="badge p-1" style="font-size: 100%; background-color: #0f6cbd; font-weight: 500;">' +
                                data.Status +
                                '</span>';
                        }

                        // Get the RecordDate from the data
                        const recordDate = data.RecordDate;

                        // Format the current date for comparison
                        const currentDateFormatted = this.datepipe.transform(
                            new Date(),
                            'dd/MM/yyyy',
                            'UTC'
                        );

                        let bgColor = '';
                        let Color = '';
                        let className = '';
                        let display = 'none';

                        if (recordDate && currentDateFormatted) {
                            const formattedRecordDate = this.datepipe.transform(
                                recordDate,
                                'dd/MM/yyyy',
                                'UTC'
                            );

                            if (
                                data.plan_id !== '1' &&
                                data.Status === 'Active'
                            ) {
                                bgColor = 'rgb(211, 232, 239)';
                                Color = 'rgb(70, 70, 70)';
                                className = 'subscriber-user';
                                display = 'block';
                            } else if (
                                formattedRecordDate === currentDateFormatted
                            ) {
                                bgColor = 'rgb(193, 198, 201)';
                                Color = 'rgb(70, 70, 70)';
                            } else {
                                // No color
                                bgColor = '';
                                Color = '';
                            }
                        }

                        const activationDate = data.ActivationDate;

                        let formattedActivationDate: string;

                        if (
                            activationDate === null ||
                            activationDate === undefined
                        ) {
                            formattedActivationDate = '--';
                        } else {
                            formattedActivationDate = this.datepipe.transform(
                                activationDate,
                                'dd/MM/yyyy',
                                'UTC'
                            );
                        }

                        const RegistrationDate: string = data.RecordDate;
                        // const date = new Date(RegistrationDate);
                        console.log(RegistrationDate, 'RESG');

                        let formattedRegistrationDate;

                        if (
                            RegistrationDate === null ||
                            RegistrationDate === undefined
                        ) {
                            formattedRegistrationDate = '--';
                        } else {
                            formattedRegistrationDate = this.datepipe.transform(
                                RegistrationDate,
                                'dd/MM/yyyy hh:mm a',
                                'UTC'
                            );
                        }

                        const firstCallDate = data.first_calldate;

                        let formattedFirstCallDate;

                        if (
                            firstCallDate === null ||
                            firstCallDate === undefined
                        ) {
                            formattedFirstCallDate = '--';
                        } else {
                            const parsedDate = new Date(firstCallDate);

                            // Check if the parsed date is not "Invalid Date"
                            if (isNaN(parsedDate.getTime())) {
                                formattedFirstCallDate = '--';
                            } else {
                                formattedFirstCallDate =
                                    parsedDate.toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                    });
                            }
                        }

                        const LastCallDate = data.last_calldate;

                        let formattedLastDate;

                        if (
                            LastCallDate === null ||
                            LastCallDate === undefined
                        ) {
                            formattedLastDate = '--';
                        } else {
                            const parsedDate = new Date(LastCallDate);

                            // Check if the parsed date is not "Invalid Date"
                            if (isNaN(parsedDate.getTime())) {
                                formattedLastDate = '--';
                            } else {
                                formattedLastDate =
                                    parsedDate.toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                    });
                            }
                        }

                        const txtcolor = 'black';
                        const userId = data.UserID || '--';
                        const status = data.Status || '';

                        const getSelected = (val: string) =>
                            val === status ? 'selected' : '';

                        return `
  <div class="card" style="background-color: ${bgColor}; color: ${Color};">
    <div class="card-body">
      <div class="row">
      
        <div class="col-md-5 space">
          <div class="text-left mt-3" style="font-size: 16px; !important;">
          <p class="mb-2 font-13 d-flex align-items-center">
            <i class="fas fa-file-signature"></i>
            &nbsp;<strong>UserID&nbsp;: &nbsp;</strong>
            <span class="ms-2 d-flex align-items-center" style="color: ${txtcolor};">
                ${data.UserID ? data.UserID : '--'}
                <span 
                class="status-badge1 ms-2-" 
                style="margin-left: 3px; cursor: pointer;" 
                UserID="${data.UserID}" 
                PlanID="${data.plan_id}">
                    ${statusBadge}
                </span>
            </span> 
            </p>    
            <p 
            class="mb-2 font-13 d-flex align-items-center justify-content-between edit-profile"
            style="cursor: pointer;"
            title="Edit Profile"
            UserID="${data.UserID}" PlanID="${data.plan_id}"
            >
            <span class="d-flex align-items-center">
                <i class='fas fa-user-tie fa-lg'></i>&nbsp;
                <strong>Name &nbsp;&nbsp;: &nbsp;</strong>
                <span class="ms-2" style="color: ${txtcolor}">
                ${data.FirstName} ${data.LastName}
                </span>
                <i 
                class="fas fa-edit" 
                style="cursor: pointer; margin-left: 3px; font-size: 20px; color: #0f6cbd;" 
                title="Edit"
                ></i>
            </span>
            </p>
            <p class="mb-2 font-13 d-flex align-items-center">
                <i class="fas fa-mobile-alt"></i>
                &nbsp;<strong>Mobile No&nbsp;: &nbsp;</strong>
                <span class="ms-2 d-flex align-items-center" style="color: ${txtcolor};">
                    ${data.MobileNo ? data.MobileNo : '--'}
                </span>
            </p>
            <p class="mb-2 font-13 d-flex align-items-center">
                <i class="fas fa-envelope"></i>
                &nbsp;<strong>Email&nbsp;: &nbsp;</strong>
                <span class="ms-2 d-flex align-items-center" style="color: ${txtcolor};">
                    ${data.EmailID ? data.EmailID : '--'}
                <span class="user-district" 
                style="width: 20px; height: 20px; display: inline-flex; align-items: center; justify-content: center; background-color: transparent; border-radius: 4px; margin-left: 4px; cursor: pointer;"
                title="User District" 
                UserID="${data.UserID}" PlanID="${data.plan_id}"
                >
                <i class="fas fa-map-marker-alt text-danger" style="font-size: 20px;"></i>
                </span>
                </span>
            </p>
          </div>
        </div>

        <div class="col-md-4">
          <div class="text-left mt-3">
            <p class="mb-1 font-13 d-flex align-items-center">
              <i class='fas fa-calendar-plus fa-lg'></i>&nbsp;&nbsp;
              <strong>Registration Date : &nbsp;</strong>
              <span class="ms-2" style="color: ${txtcolor};">${
                            formattedRegistrationDate
                                ? formattedRegistrationDate
                                : '--'
                        }</span>
            </p>
            <p class="mb-1 font-13 d-flex align-items-center">&nbsp;
              <strong>Call Initiated By&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: &nbsp;</strong>
              <span class="ms-2" style="color: ${txtcolor};">${
                            data.CallInitiatedBy ? data.CallInitiatedBy : ''
                        }</span>
            </p>
            <p class="mb-1 font-13 d-flex align-items-center">&nbsp;
              <strong>Last Call By&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : &nbsp;</strong>
              <span class="ms-2" style="color: ${txtcolor};">${
                            data.LastCallBy ? data.LastCallBy : ''
                        }</span>
            </p>
          </div>
        </div>

        <div class="col-md-3">
          <div class="text-left mt-3">
            <a
                class="btn btn-sm text-white view"
                style="margin: 0 5px; border-radius: 8px; background-color: #0f6cbd;"
                title="View"
                href="/users/users-users-details?UserId=${data.UserID}&planId=${
                            data.plan_id
                        }"
                UserID="${data.UserID}" PlanID="${data.plan_id}"
                >
                User Plan
            </a><br>
            <a
                class="btn btn-sm text-white call-alert"
                style="margin: 10px 5px 0; border-radius: 8px; background-color: #0f6cbd;"
                title="Call Alert"
                href="/users/users-users-details/call-alert?id=${
                    data.UserID
                }&planId=${data.plan_id}"
                UserID="${data.UserID}" PlanID="${data.plan_id}"
                >
                User Call Summary
            </a><br>
            <a
                class="btn btn-sm text-white view-receipt"
                style="margin: 10px 5px 0; border-radius: 8px; background-color: #0f6cbd;"
                title="Call Alert"
                href="/users/users-users-details/receipts?id=${
                    data.UserID
                }&planId=${data.plan_id}"
                UserID="${data.UserID}" PlanID="${data.plan_id}"
                >
                View Receipt
            </a><br>
            <a
                class="btn btn-sm text-white view-services"
                style="margin: 10px 5px 0; border-radius: 8px; background-color: #0f6cbd;"
                title="View Services"
                href="/users/users-users-details/services-interest?id=${
                    data.UserID
                }&planId=${data.plan_id}"
                UserID="${data.UserID}" PlanID="${data.plan_id}"
                >
                Services Interest
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
`;
                    },
                },
            ],

            drawCallback: () => {
                $('.status-badge')
                    .off('click')
                    .on('click', (e) => {
                        e.preventDefault();

                        const target = e.currentTarget;
                        const UserId = $(target).attr('data-userid');
                        const PlanId = $(target).attr('data-planid');

                        this.dialog.open(EditstatuspopupComponent, {
                            width: '500px',
                            data: {
                                userId: UserId,
                                planId: PlanId,
                            },
                        });
                    });
                $('.view-services')
                    .off('click')
                    .on('click', (e) => {
                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                        e.preventDefault();

                        const target = e.currentTarget;
                        this.planId = target.getAttribute('PlanID');
                        this.UserId = target.getAttribute('UserID');

                        localStorage.setItem('UserId', this.UserId);

                        console.log('Call Alert - UserId:', this.UserId);

                        this.router.navigate(
                            ['users/users-users-details/services-interest'],
                            {
                                state: {
                                    id: this.UserId,
                                    planId: this.planId,
                                },
                            }
                        );
                    });
                $('.view')
                    .off('click')
                    .on('click', (e) => {
                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                        e.preventDefault();

                        const target = e.currentTarget;
                        this.planId = target.getAttribute('PlanID');
                        this.UserId = target.getAttribute('UserID');

                        console.log('user idf', this.UserId);

                        this.router.navigate(['users/users-users-details'], {
                            state: { UserId: this.UserId, planId: this.planId },
                        });
                    });
                $('.status-dropdown')
                    .off('change')
                    .on('change', function () {
                        const selectedValue = $(this).val();
                        const userId = $(this).data('userid');

                        // Apply color change directly
                        switch (selectedValue) {
                            case 'Active':
                                $(this).css({
                                    backgroundColor: '#0f6cbd',
                                    color: 'white',
                                });
                                break;
                            case 'Inactive':
                                $(this).css({
                                    backgroundColor: '#ffc107',
                                    color: 'black',
                                });
                                break;
                            case 'Deactivated':
                            case 'Zero':
                                $(this).css({
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                });
                                break;
                            default:
                                $(this).css({
                                    backgroundColor: '#0f6cbd',
                                    color: 'white',
                                });
                                break;
                        }

                        console.log(
                            `User ID: ${userId}, New Status: ${selectedValue}`
                        );
                        // Optional: Call Angular service or emit to parent here
                    });

                // Set initial color on load
                $('.status-dropdown').each(function () {
                    const val = $(this).val();
                    switch (val) {
                        case 'Active':
                            $(this).css({
                                backgroundColor: '#0f6cbd',
                                color: 'white',
                            });
                            break;
                        case 'Inactive':
                            $(this).css({
                                backgroundColor: '#ffc107',
                                color: 'black',
                            });
                            break;
                        case 'Deactivated':
                        case 'Zero':
                            $(this).css({
                                backgroundColor: '#dc3545',
                                color: 'white',
                            });
                            break;
                        default:
                            $(this).css({
                                backgroundColor: '#0f6cbd',
                                color: 'white',
                            });
                            break;
                    }
                });
                $('.call-alert')
                    .off('click')
                    .on('click', (e) => {
                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                        e.preventDefault();

                        const target = e.currentTarget;
                        this.planId = target.getAttribute('PlanID');
                        this.UserId = target.getAttribute('UserID');

                        localStorage.setItem('UserId', this.UserId);

                        console.log('Call Alert - UserId:', this.UserId);

                        this.router.navigate(
                            ['users/users-users-details/call-alert'],
                            {
                                state: {
                                    id: this.UserId,
                                    planId: this.planId,
                                },
                            }
                        );
                    });
                $('.view-receipt')
                    .off('click')
                    .on('click', (e) => {
                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                        e.preventDefault();

                        const target = e.currentTarget;
                        this.planId = target.getAttribute('PlanID');
                        this.UserId = target.getAttribute('UserID');

                        localStorage.setItem('UserId', this.UserId);

                        console.log('Call Alert - UserId:', this.UserId);

                        this.router.navigate(
                            ['users/users-users-details/receipts'],
                            {
                                state: {
                                    UserId: this.UserId,
                                    planId: this.planId,
                                },
                            }
                        );
                    });

                // $('.user-district')
                //     .off('click')
                //     .on('click', (e) => {
                //         if (e.ctrlKey || e.metaKey || e.button === 1) return;
                //         e.preventDefault();

                //         const target = e.currentTarget;
                //         this.planId = target.getAttribute('PlanID');
                //         this.UserId = target.getAttribute('UserID');

                //         console.log('user idf', this.UserId);

                //         this.router.navigate(['users/userDistrcit'], {
                //             state: { UserId: this.UserId, planId: this.planId },
                //         });
                //     });

                // $('.user-district')
                //     .off('click')
                //     .on('click', (e) => {
                //         if (e.ctrlKey || e.metaKey || e.button === 1) return;
                //         e.preventDefault();

                //         const target = e.currentTarget;
                //         this.planId = target.getAttribute('PlanID');
                //         this.UserId = target.getAttribute('UserID');

                //         localStorage.setItem('UserId', this.UserId);
                //         localStorage.setItem('PlanId', this.planId);

                //         this.dialog.open(EditDistrictComponent, {
                //             width: '600px',
                //             data: {
                //                 userId: this.UserId,
                //                 planId: this.planId,
                //             },
                //         });
                //     }
                // );

                $('.user-district')
                    .off('click')
                    .on('click', (e) => {
                        if (e.ctrlKey || e.metaKey || e.button === 1) return;
                        e.preventDefault();

                        const target = e.currentTarget;
                        const UserId = target.getAttribute('UserID');
                        const PlanId = target.getAttribute('PlanID');

                        localStorage.setItem('UserId', UserId);
                        localStorage.setItem('PlanId', PlanId);

                        this.dialog
                            .open(EditDistrictComponent, {
                                width: '900px',
                                data: {
                                    userId: UserId,
                                    planId: PlanId,
                                },
                            })
                            .afterClosed()
                            .subscribe((result) => {
                                if (
                                    result &&
                                    result.action === 'add-district'
                                ) {
                                    this.router.navigate(
                                        ['users/add-user-district'],
                                        {
                                            state: {
                                                UserId: result.userId,
                                                Editproperty: false,
                                                isEdit: false,
                                                isLoading: false,
                                            },
                                        }
                                    );
                                }
                            });
                    });

                $('.edit-profile')
                    .off('click')
                    .on('click', (e) => {
                        e.preventDefault();

                        const target = e.currentTarget;
                        this.planId = target.getAttribute('PlanID');
                        this.UserId = target.getAttribute('UserID');

                        localStorage.setItem('UserId', this.UserId);

                        console.log('Edit Profile - UserId:', this.UserId);

                        this.isLoading = true;

                        if (this.UserId && this.planId) {
                            this.generalService
                                .getUsersDetails(this.UserId)
                                .subscribe(
                                    (res: any) => {
                                        this.isLoading = false;
                                        if (res && res.data) {
                                            this.usersData = res.data;

                                            this.editProfile();
                                        } else {
                                            console.warn(
                                                'User data not found.'
                                            );
                                        }
                                    },
                                    (error) => {
                                        this.isLoading = false;
                                        console.error(
                                            'Error fetching user details:',
                                            error
                                        );
                                    }
                                );
                        } else {
                            this.isLoading = false;
                        }
                    });
            },

            initComplete: () => {
                setTimeout(() => {
                    const searchInput = $('div.dataTables_filter input');

                    if (
                        !searchInput
                            .parent()
                            .hasClass('custom-search-container')
                    ) {
                        searchInput.wrap(
                            '<div class="custom-search-container position-relative d-inline-block"></div>'
                        );
                        searchInput.after(
                            '<i class="fa fa-search search-icon" style="margin-left: 10px; cursor: pointer;"></i>'
                        );
                    }
                }, 100);
            },
        };
    }

    statusOptions: string[] = ['Active', 'Inactive', 'Deactivated', 'Zero'];
    editableStatusUserId: number = null;

    getStatusBadge(status: string): string {
        switch (status) {
            case 'Active':
                return `<span class="badge p-1" style="font-size: 100%; background-color: #0fbd5dff; font-weight: 500;">Active</span>`;
            case 'Inactive':
                return `<span class="badge btn-warning p-1" style="font-size: 100%; font-weight: 500;">Inactive</span>`;
            case 'Deactivated':
                return `<span class="badge btn-danger p-1" style="font-size: 100%; font-weight: 500;">Deactivated</span>`;
            case 'Zero':
                return `<span class="badge btn-danger p-1" style="font-size: 100%; font-weight: 500;">Zero</span>`;
            default:
                return `<span class="badge p-1" style="font-size: 100%; background-color: #0f6cbd; font-weight: 500;">${status}</span>`;
        }
    }

    onStatusChange(newStatus: string, user: any): void {
        user.Status = newStatus;

        // You can call API here to persist change
        console.log('Updated user:', user.UserID, 'New Status:', newStatus);

        // Close the dropdown
        this.editableStatusUserId = null;
    }

    renderData2(data) {
        if (data === null) {
            return '--';
        } else {
            return data;
        }
    }
    renderData(data) {
        if (data === null) {
            return '--';
        } else {
            return this.datepipe.transform(data, 'yyyy-MM-dd ');
        }
    }
    ngAfterViewInit(): void {
        this.dtTrigger.next();

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            const searchInput = $('div.dataTables_filter input');

            searchInput.off();

            // Keyup handler
            searchInput.on('keyup', (event) => {
                const value = (event.target as HTMLInputElement).value.trim();

                if (event.key === 'Enter') {
                    dtInstance.search(value).draw();
                }

                if (value === '') {
                    dtInstance.search('').draw();
                }
            });

            // Click on search icon
            $(document).on(
                'click',
                '.custom-search-container .search-icon',
                () => {
                    const value = searchInput.val().toString().trim() || '';
                    dtInstance.search(value).draw();
                }
            );

            // ✅ Detect native browser clear (cross/×) click
            searchInput.on('input', () => {
                const value = searchInput.val().toString().trim() || '';
                if (value === '') {
                    dtInstance.search('').draw();
                }
            });
        });
    }
    buildQueryString(currentUser: any, status: string, dates: any) {
        let queryString = '';

        if (currentUser.franchise_Id) {
            queryString += `?franchise_Id=${currentUser.franchise_Id}`;
        } else if (status && currentUser.franchise_Id === null) {
            queryString += `?status=${status}`;
        } else if (
            dates &&
            status === '' &&
            currentUser.franchise_Id === null
        ) {
            queryString += `?endDate=${dates.endDate}&startDate=${dates.startDate}`;
        }
        if (dates && status && currentUser.franchise_Id === null) {
            queryString += `&endDate=${dates.endDate}&startDate=${dates.startDate}`;
        }
        if (dates !== undefined && status && currentUser.franchise_Id) {
            queryString += `&status=${status}&endDate=${dates.endDate}&startDate=${dates.startDate}`;
        } else if (status && currentUser.franchise_Id) {
            queryString += `&status=${status}`;
        } else if (
            dates !== undefined &&
            currentUser.franchise_Id &&
            status === ''
        ) {
            queryString += `&endDate=${dates.endDate}&startDate=${dates.startDate}`;
        }
        console.log('questy string', queryString);

        return queryString;
    }

    getUrl(dataTablesParameters: any) {
        if (this.status === 'Subscriber') {
            // console.log("user stataus",this.status)
            return `${this.generalService.getSubscriberList()}/${
                dataTablesParameters.search.value != ''
                    ? dataTablesParameters.search.value + '/'
                    : ''
            }${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
            }/${dataTablesParameters.length}${
                this.currentUser.franchise_Id
                    ? `?franchise_Id=${this.currentUser.franchise_Id}`
                    : this.dates
                    ? `?endDate=${this.dates.endDate}&startDate=${this.dates.startDate}`
                    : ''
            }${
                this.dates && this.currentUser.franchise_Id
                    ? `&endDate=${this.dates.endDate}&startDate=${this.dates.startDate}`
                    : ''
            }`;
        } else {
            return `${this.generalService.getallusers()}/${
                dataTablesParameters.search.value != ''
                    ? dataTablesParameters.search.value + '/'
                    : ''
            }${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
            }/${dataTablesParameters.length}${this.buildQueryString(
                this.currentUser,
                this.status,
                this.dates
            )}`;
        }
    }
    //  User(){
    //  this.jk = this.generalService.getallusers() + this.buildQueryString(this.currentUser,this.status,this.dates)
    //  console.log('jscnskncksnkdsnvkdsnv kdsv',this.jk)
    //  }
    onchangeSearch() {
        console.log(this.inputValue);
        if (this.inputValue != '') {
            return;
        }
        this.rerender();
    }
    onSearch() {
        this.rerender();
    }
    rerender(): void {
        if (!this.dtElement) { return; }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
        }).catch(() => {});
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(AddUserComponent, {
            width: '600px',
            data: {},
            autoFocus: false,
            maxHeight: '100vh',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.rerender();
            }
        });
    }
    openDialog1(userId: any): void {
        this.UserId = userId;
        const dialogRef = this.dialog.open(this.content1, {
            width: '600px',
            data: {},
            autoFocus: false,
            maxHeight: '90vh',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }
    close() {
        this.dialog.closeAll();
        this.addUserForm.reset();
    }

    viewReceipt() {
        this.router.navigate(['users/users-users-details/receipts/'], {
            state: { UserId: this.UserId },
        });
    }
    callAlert() {
        this.router.navigate(['/users/call-alert'], {
            state: { id: this.UserId },
        });
        this.dialog.closeAll();
    }
    viewPlan(id, plan) {
        const dialogRef = this.dialog.open(SubscriptionPlanComponent, {
            width: '600px',
            data: { UserId: id, PlanId: plan },
            autoFocus: false,
            maxHeight: '90vh',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            console.log('The dialog was closed');
        });
    }

    editProfile() {
        const dialogRef = this.dialog.open(AddUserComponent, {
            width: '600px',
            data: {
                userData: this.usersData.user,
                app: this.usersData.username,
                isEdit: true,
            },
            autoFocus: false,
            maxHeight: '80vh',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                // Refresh the user LIST table so the edited status/details show
                // immediately (replaces the old full-page reload).
                // NOTE: do NOT call getUsersDetails() here — it overwrites
                // this.status (the page-level list filter/title) with the edited
                // user's individual status, which mislabels the grid as
                // "<Status> Users" and filters out everything else on search.
                this.rerender();
            }
        });
    }
}
